<template>
  <div>

    <filterbar currentView="map"></filterbar>

    <div v-if="dataloaded">

      <div class="container wide_container accolister_container">
        <div v-if="!receivedAccos" class="emptyacco">
          <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="sad-tear"
            class="svg-inline--fa fa-sad-tear fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 496 512">
            <path fill="currentColor"
              d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm8-152c-13.2 0-24 10.8-24 24s10.8 24 24 24c23.8 0 46.3 10.5 61.6 28.8 8.1 9.8 23.2 11.9 33.8 3.1 10.2-8.5 11.6-23.6 3.1-33.8C330 320.8 294.1 304 256 304zm-88-64c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-165.6 98.8C151 290.1 126 325.4 126 342.9c0 22.7 18.8 41.1 42 41.1s42-18.4 42-41.1c0-17.5-25-52.8-36.4-68.1-2.8-3.7-8.4-3.7-11.2 0z">
            </path>
          </svg>
          <h1>No Results!</h1>
          <p>
            Unfortunately, we do not have any accomodations yet for the applied
            filters.<br />Deselect some filters, change the dates, or please
            come back another time!
          </p>
        </div>
        <div v-else class="accopagelist">
          <p v-if="this.search.toString()" class="searchDescription">
            <span>Searching </span>
            <span v-if="this.search.get('name')">for "{{ this.search.get('name') }}"</span>
            <span v-if="this.search.get('checkin')">from the {{ this.search.get('checkin') | smallDate }}</span>
            <span v-if="this.search.get('checkout')">until the {{ this.search.get('checkout') | smallDate }}</span>
            <span v-if="this.search.get('location')">in {{ this.search.get('location') }}</span>
            <span v-if="this.search.get('guests')">for {{ this.search.get('guests') }}
              <span v-if="this.search.get('guests') > 1">persons</span>
              <span v-else>person</span>
            </span>
            <span v-if="this.search.get('features')">with filters</span>
            -
            <span class="clear" @click="clearSearch()">clear</span>
          </p>
          <p class="searchDescription">
            {{ receivedAccos.length }}
            Accomodations
          </p>

          <div class="acco_lister_item skeleton" v-for="(item, index) in receivedAccos" :key="index"
            :id="'acco-' + item.id" @mouseover="(showMarkerByIndex = item.id), moveMap(item.id)"
            @mouseout="(showMarkerByIndex = null), moveMap(null)">
            <a v-bind:href="`${currentUrl}/acco/${item.slug}?${params}`">
              <div class="room-thumb">
                <img v-bind:src="mipmap(item.spotlightimage, 200)" alt="" class="room-image" srcset="" />
              </div>
              <div class="main">
                <div class="info">
                  <h5>{{ item.name }}</h5>
                  <span class="location">
                    <span v-if="!singleCountry">
                      <span v-bind:class="'fi fi-' + item.country.toLowerCase()"></span>
                    </span> {{ item.city }}<span v-if="item.city && item.state">, </span>{{ item.state }}
                  </span>
                  <div v-if="JSON.parse(item.description).EN < 200" class="specs">
                    {{ JSON.parse(item.description).EN }}
                  </div>
                  <div v-else class="specs">
                    {{ JSON.parse(item.description).EN.split(".")[0] + "." }}
                  </div>
                </div>
                <div v-if="item.prices && item.prices.priceperNight / item.prices.multiplier <
                  99999 &&
                  item.prices.priceperNight / item.prices.multiplier >
                  item.prices.priceperNight &&
                  !item.prices.priceperNight < 1
                  " class="price discount">
                  <div class="dicounttext">Discount!</div>

                  <div v-if="item.prices.price != 0">
                    <div class="prevprice">
                      €{{
                        (item.prices.price / item.prices.multiplier).toFixed(2)
                      }}
                    </div>
                    <div class="fullprice">
                      <span>total</span>
                      €{{ item.prices.price.toFixed(2) }}
                    </div>
                  </div>
                  <div class="pricechange" v-else-if="item.prices">
                    <div class="prevprice">
                      €{{
                        (
                          item.prices.priceperNight / item.prices.multiplier
                        ).toFixed(2)
                      }}
                    </div>
                    <div class="nowprice" v-if="item.prices">
                      €{{ item.prices.priceperNight.toFixed(2) }}
                      <span> / Night</span>
                    </div>
                  </div>
                </div>
                <div v-else-if="item.prices && item.prices.priceperNight / item.prices.multiplier <
                  99999 &&
                  item.prices.priceperNight / item.prices.multiplier <
                  item.prices.priceperNight &&
                  !item.prices.priceperNight < 1
                  " class="price discount">
                  <div class="dicounttext">High demand!</div>

                  <div v-if="item.prices.price != 0">
                    <div class="fullprice">
                      <span>total</span>
                      €{{ item.prices.price.toFixed(2) }}
                    </div>
                  </div>
                  <div v-else-if="item.prices">
                    <div class="nowprice">
                      €{{ item.prices.priceperNight.toFixed(2)
                      }}<span> / Night</span>
                    </div>
                  </div>
                </div>
                <div v-else-if="item.prices && !item.prices.priceperNight < 1" class="price">
                  <div v-if="item.prices.price != 0 &&
                    item.prices.price.toFixed(2) !=
                    item.prices.priceperNight.toFixed(2)
                    " class="totalPrice">
                    <span>Total</span>
                    €{{ item.prices.price.toFixed(2) }}
                  </div>
                  €{{ item.prices.priceperNight.toFixed(2) }} / Night
                </div>
              </div>
              <div class="seeProperty">Show more</div>
            </a>
          </div>
        </div>
        <l-map v-if="receivedAccos" class="map" :zoom="zoom" :center="center" :max-zoom="maxZoom">
          <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
          <l-marker v-for="(item, index) in markers" :key="'marker-' + index" :lat-lng="item"
            @click="scrollMarker(item[2])">
            <l-icon :icon-anchor="staticAnchor" class-name="markerClass">
              <div class="marker" :id="'marker-' + item[2]" v-bind:class="{
                active: showMarkerByIndex === item[2],
                inactive:
                  showMarkerByIndex !== item[2] && showMarkerByIndex !== null,
              }"></div>
            </l-icon>
          </l-marker>
        </l-map>
      </div>
    </div>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker, LIcon } from "vue2-leaflet";
import moment from "moment";
import VueCookies from 'vue-cookies'

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
  },
  data() {
    return {
      sortBy: "name",
      keyword: "",
      showMarkerByIndex: null,
      staticAnchor: [16, 37],
      dataloaded: false,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      zoom: 13,
      maxZoom: 18,
      markers: [],
      currentUrl: "",
      defaultCenter: [],
      markerinView: "",
      params: [],
      singleCountry: false,
      search: new URLSearchParams(window.location.search),
    };
  },

  methods: {
    mipmap(src, res) {
      if (src) {
        if (src.includes('https://media.xmlcal.com')) {
          var imgblocks = src.split("/");
          var imgfile = imgblocks[imgblocks.length - 1];
          var thumbnailimgsmall =
            imgfile.split(".")[0] + "." + res + "." + imgfile.split(".")[1];
          imgblocks[imgblocks.length - 1] = thumbnailimgsmall;
          return imgblocks.join("/");
        } else {
          return src;
        }
      } else {
        return src;
      }
    },
    clearSearch() {
      for (const [key, value] of this.search.entries()) {
        VueCookies.remove(key)
      }
      VueCookies.remove('propertyName')
      VueCookies.remove('checkin')
      VueCookies.remove('checkout')
      VueCookies.remove('country')
      VueCookies.remove('numChildren')
      VueCookies.remove('numAdult')
      VueCookies.remove('location')
      VueCookies.remove('accomodation')
      VueCookies.remove('city')
      window.location.href = this.currentUrl + '/accomodations/'
    },
    moveMap(id) {
      if (id != null) {
        if (id !== this.markerinView) {
          var marker = this.markers.find((element) => element[2] === id);
          this.markerinView = id;
          this.center = [marker[0], marker[1]];
        }
      }
    },
    scrollMarker(id) {
      const element = document.getElementById("acco-" + id);
      const yOffset = -element.offsetHeight;
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
      element.classList.add("focus");
      setTimeout(function () {
        element.classList.remove("focus");
      }, 1000);
    },
    async getData() {
      if (!window.location.search) {
        try {
          let response = await fetch(
            this.$BMB_API +'api/' +
            this.$clientID +
            "/getProperties?showAll=True&getPrices=True",
            {
              headers: {
                "X-Requested-With": "XMLHttpRequest",
              },
            }
          );
          this.products = await response.json();
          console.log(this.products);

          this.dataloaded = true;
        } catch (error) {
          console.log(error);
        }
      } else {
        console.log(
          this.$BMB_API +'api/' +
          this.$clientID +
          "/getProperties" +
          window.location.search +
          "&getPrices=true")
        try {
          let response = await fetch(
            this.$BMB_API +'api/' +
            this.$clientID +
            "/getProperties" +
            window.location.search +
            "&getPrices=true",
            {
              headers: {
                "X-Requested-With": "XMLHttpRequest",
              },
            }
          );
          this.products = await response.json();
          console.log(this.products);
          this.dataloaded = true;
        } catch (error) {
          console.log(error);
        }
      }

      if (this.products.data) {
        this.singleCountry = true;
        let currentCountry = this.products.data[0].country;

        for (let i = 0; i < this.products.data.length; i++) {
          if (this.products.data[i].country != currentCountry) {
            this.singleCountry = false;
          }
          this.markers.push([
            this.products.data[i].latitude,
            this.products.data[i].longitude,
            this.products.data[i].id,
          ]);
        }
        let x = 0.0;
        let y = 0.0;
        let z = 0.0;

        var latestlatitude = this.markers[0][0];
        let latestlongitude = this.markers[0][1];

        for (let coord of this.markers) {
          let latitude = (coord[0] * Math.PI) / 180;
          let longitude = (coord[1] * Math.PI) / 180;

          x += Math.cos(latitude) * Math.cos(longitude);
          y += Math.cos(latitude) * Math.sin(longitude);
          z += Math.sin(latitude);
        }

        let total = this.markers.length;

        x = x / total;
        y = y / total;
        z = z / total;

        let centralLongitude = Math.atan2(y, x);
        let centralSquareRoot = Math.sqrt(x * x + y * y);
        let centralLatitude = Math.atan2(z, centralSquareRoot);

        this.center = [
          (centralLatitude * 180) / Math.PI,
          (centralLongitude * 180) / Math.PI,
        ];

        this.center = this.markers[0];
        this.defaultCenter = this.center;
      }
    },
  },

  created() {
    this.getData();
    this.currentUrl = window.location.origin;
    this.params = new URLSearchParams(document.location.search);
  },

  filters: {
    smallDate: function (date) {
      return moment(date).format('Do MMM');
    }
  },

  computed: {
    receivedAccos: function () {
      if (this.dataloaded) {
        return this.products.data;
      }
    },
  },
};
</script>
